import { useState } from "react";

const FAQS = [
  {
    idx: 0,
    title: "Как проходит аудит и сколько он занимает времени?",
    content:
      "Стоимость создания Web3/криптопродукта зависит от его сложности, объема функционала, этапов разработки и требований к дизайну. Чтобы определить точную стоимость, напишите нам — обсудим ваш проект и подготовим персональное предложение",
  },
  {
    idx: 1,
    title: "Что я получу в результате аудита?",
    content:
      "Стоимость создания Web3/криптопродукта зависит от его сложности, объема функционала, этапов разработки и требований к дизайну. Чтобы определить точную стоимость, напишите нам — обсудим ваш проект и подготовим персональное предложение",
  },
  {
    idx: 2,
    title: "Как быстро я увижу результаты после внедрения рекомендаций?",
    content:
      "Стоимость создания Web3/криптопродукта зависит от его сложности, объема функционала, этапов разработки и требований к дизайну. Чтобы определить точную стоимость, напишите нам — обсудим ваш проект и подготовим персональное предложение",
  },
  {
    idx: 3,
    title:
      "Мне нужно заказывать полный аудит или можно выбрать отдельные части?",
    content:
      "Стоимость создания Web3/криптопродукта зависит от его сложности, объема функционала, этапов разработки и требований к дизайну. Чтобы определить точную стоимость, напишите нам — обсудим ваш проект и подготовим персональное предложение",
  },
  {
    idx: 4,
    title: "Сколько стоит UX/UI аудит?",
    content:
      "Стоимость создания Web3/криптопродукта зависит от его сложности, объема функционала, этапов разработки и требований к дизайну. Чтобы определить точную стоимость, напишите нам — обсудим ваш проект и подготовим персональное предложение",
  },
];

function AuditFaq() {
  const [currentDD, setCurrentDD] = useState(undefined);

  function handleClick(idx) {
    if (currentDD === idx) {
      setCurrentDD(undefined);
    } else {
      setCurrentDD(idx);
    }
  }

  return (
    <div className="faq__container">
      {FAQS.map((item) => (
        <div
          onClick={() => handleClick(item.idx)}
          key={item.idx}
          className={
            currentDD === item.idx ? "faqitem faqitem--active" : "faqitem"
          }
        >
          <div className="faqtitle">
            {item.title}
            <div className="faqcorss" />
          </div>

          <div className="faqtext">{item.content}</div>
        </div>
      ))}
    </div>
  );
}

export default AuditFaq;
